var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 19.625L10.2667 16.4167H5.50008C5.25697 16.4167 5.02381 16.3201 4.8519 16.1482C4.67999 15.9763 4.58342 15.7432 4.58342 15.5V5.51112C4.58342 5.26801 4.67999 5.03485 4.8519 4.86294C5.02381 4.69103 5.25697 4.59446 5.50008 4.59446H20.1667C20.4099 4.59446 20.643 4.69103 20.8149 4.86294C20.9868 5.03485 21.0834 5.26801 21.0834 5.51112V15.5C21.0834 15.7432 20.9868 15.9763 20.8149 16.1482C20.643 16.3201 20.4099 16.4167 20.1667 16.4167H15.4001L12.8334 19.625ZM14.5192 14.5834H19.2501V6.42779H6.41675V14.5834H11.1477L12.8334 16.6899L14.5192 14.5834ZM1.83341 0.833374H17.4167V2.66671H2.75008V12.75H0.916748V1.75004C0.916748 1.50693 1.01333 1.27377 1.18523 1.10186C1.35714 0.929951 1.5903 0.833374 1.83341 0.833374Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.f0ef2de1bdbb80eef9a774fc2f4c35b0.svg";
export { ForwardRef as ReactComponent };